import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/ui/icon";

type NoteDropdownProps = {
  canEdit: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
};

export function NoteDropdown({ canEdit, onEdit, onDelete }: NoteDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center -m-2.5 p-2.5 sm:m-0 sm:p-0 opacity-[0.65] focus:outline-none"
        >
          <Icon
            name="IconDotGrid1x3Horizontal"
            size={16}
            className="text-foreground"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-36">
        {canEdit && onEdit && (
          <DropdownMenuItem onClick={onEdit}>
            <Icon
              name="IconEditBig"
              size={14}
              className="text-foreground opacity-[0.65]"
            />
            Edit
          </DropdownMenuItem>
        )}
        {canEdit && onEdit && onDelete && <DropdownMenuSeparator />}
        {canEdit && onDelete && (
          <DropdownMenuItem variant="destructive" onClick={onDelete}>
            <Icon name="IconTrashCan" size={14} className="text-current" />
            Delete
          </DropdownMenuItem>
        )}
        {!canEdit && (
          <DropdownMenuItem disabled>
            <span className="text-foreground/40">No actions available</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
